export enum OpenAppIncentive {
  TRY_APP_BUTTON = 'try-app-button',
  EDIT_IMAGE_BUTTON = 'edit-image-button',
  CREATE_IMAGE_BUTTON = 'create-image-button',
}
